import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Oauth2Service } from '../services';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private oauth2Service: Oauth2Service,
              private router: Router) { }

  canActivate(): boolean {
    if (this.oauth2Service.isLoggedIn()) {
      return true;
    } else {
      this.router.navigate(['/login']);
      return false;
    }
  }
}
